import { NavLink } from 'react-router-dom'
import { clearSession } from '../lib/auth'
import { Logo } from './Logo'
import { useBrandFilter, type BrandFilter } from '../lib/brand'

export function Nav() {
  const [brand, setBrand] = useBrandFilter()

  const tabs = [
    { to: '/',        label: 'To Review' },
    { to: '/matched', label: 'Matched' },
    { to: '/history', label: 'History' },
    { to: '/health',  label: 'Health' },
    { to: '/omega',   label: 'Omega' },
    { to: '/paycom',  label: 'Pay.com' },
  ]

  const logoBrand = brand === 'ALL' ? null : brand

  return (
    <header className="border-b border-slate-800">
      <div className="max-w-[1600px] mx-auto px-6 py-3 flex items-center justify-between gap-6">
        <div className="flex items-center gap-6 min-w-0">
          <div className="flex items-center gap-3 shrink-0">
            <Logo brand={logoBrand} className="h-5 w-auto" />
          </div>
          <nav className="flex gap-1 overflow-x-auto">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded text-sm whitespace-nowrap ${
                    isActive
                      ? 'bg-slate-800 text-white'
                      : 'text-slate-400 hover:text-white hover:bg-slate-900'
                  }`
                }
              >
                {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <select
            value={brand}
            onChange={(e) => setBrand(e.target.value as BrandFilter)}
            className="bg-slate-800 border border-slate-700 rounded px-2 py-1 text-sm text-slate-200"
            title="Filter by brand"
          >
            <option value="ALL">All brands</option>
            <option value="WOWVEGAS">WOW Vegas</option>
            <option value="ROLLA">Rolla</option>
          </select>
          <button
            onClick={() => {
              clearSession()
              window.location.reload()
            }}
            className="text-sm text-slate-400 hover:text-white"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  )
}
